import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {googleOverviewArticle_template} from "../components/templates/googleOverviewArticle_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class googleOverviewArticle extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlPagePercentageData: XMLHttpRequestHandler;
    protected XHRHdlArticlesSuggestion: XMLHttpRequestHandler;
    protected XHRHdlAutoCompleteSuggestions: XMLHttpRequestHandler;
    protected googleOverviewArticle_template: googleOverviewArticle_template;

    protected getModuleName(){
        return "googleOverviewArticle";
    }

    buildContent() : Array<Element>{

        this.googleOverviewArticle_template = new googleOverviewArticle_template( "googleOverviewArticle", this.viewModel, this );
        this.template = this.googleOverviewArticle_template;

        return [this.googleOverviewArticle_template.build()];
    }

    public fillPage() : void{

        this.googleOverviewArticle_template.buildDatePickerCalendar();
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/googleOverview/list_form_data/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.googleOverviewArticle_template.validationsList.clearMessages();
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();

                if (responseParsed.hasGoogleOverviewArticleReportReadPermission){

                    obj.getListData();
                }
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.googleOverviewArticle_template.builtTemplate);
            }
        };
    }

    public getListData(): void{

        this.getPagePercentageData();

        this.loadingIn(this.googleOverviewArticle_template.builtTemplate.children.namedItem("list-results"));
        this.loadingIn(this.googleOverviewArticle_template.builtTemplate.children.namedItem("graph-results"));

        let subViewModel = this.template.getViewModelForRequest();
        let baseApiUrl = '/api/googleOverviewArticle/list_data';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.googleOverviewArticle_template.resetSelectedRows();
                obj.googleOverviewArticle_template.validationsList.clearMessages();
                obj.updateList(responseParsed);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.googleOverviewArticle_template.builtTemplate.children.namedItem("list-results"));
                obj.loadingOut(obj.googleOverviewArticle_template.builtTemplate.children.namedItem("graph-results"));
            }
        };
    }

    public getPagePercentageData(): void{

        this.googleOverviewArticle_template.getTemplateViewModel().isPercentageLoading(1);

        if( this.XHRHdlPagePercentageData ){
            this.XHRHdlPagePercentageData.cancelAndReset();
        }

        let subViewModel = this.googleOverviewArticle_template.getViewModelForRequest();

        let usrReq_url: string = '/api/googleOverviewArticle/pagePercentage';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlPagePercentageData = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdlPagePercentageData.onReadyStateFunction = this.onPagePercentageDataReturn;
        this.XHRHdlPagePercentageData.execute();
    }

    public getGoogleOverviewListDataForCSV() {
        this.loadingIn(this.googleOverviewArticle_template.builtTemplate.children.namedItem("list-results"));
        this.loadingIn(this.googleOverviewArticle_template.builtTemplate.children.namedItem("graph-results"));

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.googleOverviewArticle_template.getViewModelForRequest();

        let usrReq_url: string = '/api/googleOverviewArticle/csv/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGoogleOverviewPageDataReturn;
        this.XHRHdl.execute();
    }

    protected onPagePercentageDataReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.googleOverviewArticle_template.validationsList.clearMessages();
                obj.googleOverviewArticle_template.setPercentages(responseParsed.pagePercentage);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.googleOverviewArticle_template.getTemplateViewModel().isPercentageLoading(0);
            }
        };
    }

    protected onGoogleOverviewPageDataReturn(req, obj) {

        return function() {

            if (req.request.readyState == 4) {
                let responseParsed = JSON.parse(req.request.response);

                console.log(responseParsed);

                if(  req.request.status == 200  ) {

                    obj.googleOverviewArticle_template.setGoogleOverviewPageCsvData(responseParsed.data);
                    obj.googleOverviewArticle_template.exportGoogleOverviewPageCsv();
                }

                obj.loadingOut(obj.googleOverviewArticle_template.builtTemplate.children.namedItem("list-results"));
                obj.loadingOut(obj.googleOverviewArticle_template.builtTemplate.children.namedItem("graph-results"));
            }
        };
    }


    protected updateFilters(responseParsed: any) {

        this.googleOverviewArticle_template.setBrandFilterItems(responseParsed.departments);
        this.googleOverviewArticle_template.setDateLevelsItems();
        this.googleOverviewArticle_template.setDataViewsItems();
        this.googleOverviewArticle_template.setFilterSources();
        this.googleOverviewArticle_template.setDefaultDates(responseParsed.maxSearchConsoleDate);
        this.googleOverviewArticle_template.setFilterInitiatives(responseParsed.initiatives);
        this.googleOverviewArticle_template.setFilterNetworkCategories(responseParsed.groupedNetworkCategories);
        this.googleOverviewArticle_template.setFilterIntents(responseParsed.intents);
        this.googleOverviewArticle_template.setFilterContentTypes(responseParsed.groupedContentTypes);
        this.googleOverviewArticle_template.setPublishedDatesDisablerItems();
        this.googleOverviewArticle_template.setHasGoogleOverviewArticleReportReadPermission(responseParsed.hasGoogleOverviewArticleReportReadPermission);

        // Default selection on first load.
        this.googleOverviewArticle_template.filterSources.getTemplateViewModel().selectedItems(["search", 'discover', 'googleNews']);
    }

    protected updateList(responseParsed: any) {

        this.googleOverviewArticle_template.setHeader(responseParsed.headers);

        if (this.googleOverviewArticle_template.getTemplateViewModel().dataViewSelected() == "table") {

            this.googleOverviewArticle_template.setTableData(responseParsed.data);
            this.googleOverviewArticle_template.updateGraphData([]);
        }else {

            this.googleOverviewArticle_template.setTableData([]);
            this.googleOverviewArticle_template.updateGraphData(responseParsed.data);
        }
    }

    protected filterSingleDateOnChange() {

        this.getListData();
    }

    protected filterMultipleSelectorOnChange() {

        this.getListData();
    }

    protected filterDateOnChange() {

        this.getListData();
    }

    protected filterSimpleOnChange() {

        this.getListData();
    }

    public filterDropdownOnChange(){

        this.togglePublishDatePicker();
        this.getListData();
    }

    private togglePublishDatePicker(): void {

        this.googleOverviewArticle_template.setPublishedDatePickerEnabled(
            this.googleOverviewArticle_template.isPublishDatesPickerEnabled()
        );
    }

    protected getArticlesSuggestion(keyword){

        if(this.XHRHdlArticlesSuggestion){

            this.XHRHdlArticlesSuggestion.cancelAndReset();
        }

        let brands = null;
        if (this.googleOverviewArticle_template.filterBrand.getTemplateViewModel().selectedOption() != 'network') {
            brands = [this.googleOverviewArticle_template.filterBrand.getTemplateViewModel().selectedOption()];
        }

        let subViewModel = {

            filters:{

                keyword: keyword,
                brands: brands,
            }
        };

        let usrReq_url: string = '/api/emakiArticleSuggestions/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdlArticlesSuggestion = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdlArticlesSuggestion.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdlArticlesSuggestion.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data) {

                    obj.googleOverviewArticle_template.setFilterArticles(responseParsed.data);
                }
            });

            obj.googleOverviewArticle_template.deactivateLoading();
        }
    }

    protected getAutoCompleteSuggestions(id, keyword){

        let subViewModel = {filters: {keyword: keyword}};
        let usrReq_url: string = '/api/emakiUsers/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdlAutoCompleteSuggestions = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdlAutoCompleteSuggestions.onReadyStateFunction = this.onGetAutoCompleteUsersSuggestionsReturn;
        this.XHRHdlAutoCompleteSuggestions.execute();
    }

    protected onGetAutoCompleteUsersSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data){

                    obj.googleOverviewArticle_template.setFilterUsers(responseParsed.data);
                }
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.googleOverviewArticle_template.deactivateLoading();
            }
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/googleOverviewArticle.ts